export default __webpack_public_path__ + "static/media/2.3ab92098.svg";